import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import parseBannerMessage from '@/features/authentication/functions/parseBannerMessage';
import TopBanner from '../TopBanner';

/**
 * Operator-authored notice across the top of every signed-in page, driven by
 * the `inAppBanner` LaunchDarkly flag. Same JSON shape as the login page's
 * `bannerMessage`; `placement` is ignored here, since this is always full-bleed.
 */
const InAppBanner = () => {
  const { inAppBanner } = useFlags();
  const banner = useMemo(() => parseBannerMessage(inAppBanner), [inAppBanner]);

  if (!banner) return null;

  return <TopBanner severity={banner.severity} html={banner.text} />;
};

export default InAppBanner;
